/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-10 15:15:33
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 13:44:39
 */
export default [

    {
        path: "ChannelRecharge",
        name: "CHANNEL_RECHARGE",
        meta: {
            title: "渠道充值",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/ChannelRecharge.vue"),
    },

    {
        path: "ChannelConsumption",
        name: "CHANNEL_CONSUMPTION",
        meta: {
            title: "渠道消费",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/ChannelConsumption.vue"),
    },

    {
        path: "CapitalAccount",
        name: "CAPITAL_ACCOUNT",
        meta: {
            title: "资金账户",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/CapitalAccount.vue"),
    },
    {
        path: "AccountType",
        name: "ACCOUNT_TYPE",
        meta: {
            title: "账户类型",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/AccountType.vue"),
    },
    {
        path: "Compensation",
        name: "COMPENSATION",
        meta: {
            title: "渠道赔付",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/Compensation.vue"),
    },
    {
        path: "Withdrawal",
        name: "WITHDRAWAL",
        meta: {
            title: "渠道提现",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/financial/Withdrawal.vue"),
    },

    // CapitalAccount

    //finance:consumption:query
    //finance:consumption:add
    //finance:consumption:detail
];